/* ── Product gallery: 1-at-a-time + seamless infinite wrap on desktop ── */
document.addEventListener('click', function (e) {
  if (window.innerWidth < 750) return;
  var mediaGallery = e.target.closest('media-gallery.media-gallery--carousel');
  if (!mediaGallery) return;
  var btn = e.target.closest('.slideshow-control--next, .slideshow-control--previous');
  if (!btn) return;
  var slideshow = mediaGallery.querySelector('slideshow-component');
  if (!slideshow || typeof slideshow.select !== 'function') return;

  e.stopImmediatePropagation();

  var isNext = btn.classList.contains('slideshow-control--next');
  var slides = Array.from(slideshow.querySelectorAll('slideshow-slide:not(.qs-clone)'));
  var scroller = slideshow.querySelector('slideshow-slides');
  if (!slides.length || !scroller) return;

  var current = slideshow.current;
  var last = slides.length - 1;
  var target = current + (isNext ? 1 : -1);

  // Normal advance — no wrap needed
  if (target >= 0 && target <= last) {
    slideshow.select(target, e);
    return;
  }

  // Seamless infinite wrap via clone trick
  var step = slides[0].offsetWidth + (parseFloat(getComputedStyle(scroller).columnGap) || 0);

  scroller.style.overflowAnchor = 'none';
  scroller.style.scrollSnapType = 'none';

  if (isNext) {
    // Forward: append clone of first slide, scroll forward, snap back
    var clone = slides[0].cloneNode(true);
    clone.classList.add('qs-clone');
    clone.style.cssText += ';content-visibility:visible!important;flex-shrink:0!important;';
    scroller.appendChild(clone);
    scroller.scrollBy({ left: step, behavior: 'smooth' });

    var done = false;
    function finishFwd() {
      if (done) return; done = true;
      scroller.scrollTo({ left: 0, behavior: 'instant' });
      clone.remove();
      scroller.style.scrollSnapType = '';
      scroller.style.overflowAnchor = '';
    }
    scroller.addEventListener('scrollend', function h() { finishFwd(); scroller.removeEventListener('scrollend', h); });
    setTimeout(finishFwd, 700);

  } else {
    // Backward: prepend clone of last slide, offset, scroll back, snap to last
    var clone = slides[last].cloneNode(true);
    clone.classList.add('qs-clone');
    clone.style.cssText += ';content-visibility:visible!important;flex-shrink:0!important;';
    scroller.insertBefore(clone, slides[0]);
    scroller.scrollBy({ left: step, behavior: 'instant' });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scroller.scrollBy({ left: -step, behavior: 'smooth' });

        var done = false;
        function finishBwd() {
          if (done) return; done = true;
          // While clone is still at start, last real slide is at offsetLeft - step
          scroller.scrollTo({ left: slides[last].offsetLeft - step, behavior: 'instant' });
          clone.remove();
          scroller.style.scrollSnapType = '';
          scroller.style.overflowAnchor = '';
        }
        scroller.addEventListener('scrollend', function h() { finishBwd(); scroller.removeEventListener('scrollend', h); });
        setTimeout(finishBwd, 700);
      });
    });
  }
}, true);

/* ── Hover image: only crossfade once second image has loaded ── */
(function () {
  function initGallery(gallery) {
    var slide2 = gallery.querySelector('slideshow-slide:nth-child(2)');
    if (!slide2) return;
    var img = slide2.querySelector('img');
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) {
      gallery.classList.add('hover-img-ready');
    } else {
      img.addEventListener('load', function () {
        gallery.classList.add('hover-img-ready');
      }, { once: true });
    }
  }

  function scanGalleries(root) {
    (root || document).querySelectorAll('.card-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scanGalleries(); });
  } else {
    scanGalleries();
  }

  // Pick up cards injected later (infinite scroll, recommendations, etc.)
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card-gallery')) {
          initGallery(node);
        } else {
          scanGalleries(node);
        }
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
}());

/* ── Size hover chevron nav — pointerdown for instant response ── */
document.addEventListener('pointerdown', function (e) {
  var nav = e.target.closest('.qs-size-nav');
  if (!nav) return;
  e.preventDefault();
  e.stopPropagation();
  var inner = nav.closest('.qs-size-hover').querySelector('.qs-size-hover__inner');
  if (!inner) return;
  var step = inner.clientWidth * 0.75;
  inner.scrollBy({ left: nav.classList.contains('qs-size-nav--prev') ? -step : step, behavior: 'smooth' });
});

document.addEventListener('click', function (e) {
  // Swallow click on nav so card doesn't navigate
  if (e.target.closest('.qs-size-nav')) { e.preventDefault(); e.stopPropagation(); return; }

  var btn = e.target.closest('.qs-size-btn');
  if (!btn) return;
  if (btn.classList.contains('qs-size-btn--sold-out')) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('qs-size-btn--loading');

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.classList.remove('qs-size-btn--loading');
      btn.classList.add('qs-size-btn--added');
      var original = btn.textContent;
      btn.textContent = '✓';
      // Update cart count if element exists
      var cartCount = document.querySelector('[data-cart-count], .cart-count, .cart__count');
      if (cartCount) {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cartCount) cartCount.textContent = cart.item_count;
          });
      }
      setTimeout(function () {
        btn.classList.remove('qs-size-btn--added');
        btn.textContent = original;
      }, 1800);
    })
    .catch(function () {
      btn.classList.remove('qs-size-btn--loading');
    });
});

/* ── Product card skeleton loader ── */
(function () {
  function markLoaded(gallery, instant) {
    if (!gallery) return;
    if (instant) {
      // Image already in browser cache — skip transition to avoid flicker on re-scroll
      gallery.classList.add('qs-media-instant');
    }
    gallery.classList.add('qs-media-loaded');
    // After fade completes, stop the animation so scroll repaints don't re-trigger shimmer
    gallery.addEventListener('transitionend', function () {
      gallery.style.setProperty('animation', 'none');
    }, { once: true });
  }

  function removeSkeleton(card, instant) {
    card.style.setProperty('--skeleton-opacity', '0');
    markLoaded(card.querySelector('.card-gallery'), instant);
    setTimeout(function () { card.removeAttribute('data-skeleton'); }, instant ? 0 : 500);
  }

  function initSkeletons() {
    document.querySelectorAll('product-card:not([data-skeleton-init])').forEach(function (card) {
      card.setAttribute('data-skeleton-init', '');
      var img = card.querySelector('.card-gallery img');
      if (!img) { removeSkeleton(card, true); return; }
      if (img.complete && img.naturalHeight > 0) {
        // Already loaded — instant, no shimmer shown at all
        removeSkeleton(card, true);
      } else {
        card.setAttribute('data-skeleton', '');
        img.addEventListener('load',  function () { removeSkeleton(card, false); }, { once: true });
        img.addEventListener('error', function () { removeSkeleton(card, false); }, { once: true });
      }
    });

    // PDP main media shimmer
    document.querySelectorAll('.product-media-container:not([data-skeleton-init])').forEach(function (wrap) {
      wrap.setAttribute('data-skeleton-init', '');
      var img = wrap.querySelector('img');
      if (!img) { wrap.classList.add('qs-media-instant'); return; }
      if (img.complete && img.naturalHeight > 0) {
        wrap.classList.add('qs-media-instant');
      } else {
        img.addEventListener('load',  function () { wrap.classList.add('qs-media-loaded'); }, { once: true });
        img.addEventListener('error', function () { wrap.classList.add('qs-media-loaded'); }, { once: true });
      }
    });

    // Smooth fade for lazy loaded images in gallery
    document.querySelectorAll('.card-gallery img[loading="lazy"]:not([data-fade-init])').forEach(function (img) {
      img.setAttribute('data-fade-init', '');
      if (img.complete && img.naturalHeight > 0) {
        img.classList.add('qs-lazy-loaded', 'qs-media-instant');
      } else {
        img.addEventListener('load', function () { img.classList.add('qs-lazy-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('qs-lazy-loaded'); }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkeletons);
  } else {
    initSkeletons();
  }

  new MutationObserver(initSkeletons).observe(document.body, { childList: true, subtree: true });
})();
